import { gql } from '@apollo/client'

export const createOneCredit = gql`
    mutation CreateOneCredit( $userId: String!, $amount: Float!, $expiryDate: DateTimeISO!) {
        createOneCredit(userId: $userId, amount: $amount, expiryDate: $expiryDate) {
            amount
            id
            expiryDate
            productName
            productType
        }
    }
`
export const updateOneCredit = gql`
    mutation UpdateOneCredit($creditId: String!, $amount: Float, $expiryDate: DateTimeISO) {
        updateOneCredit(creditId: $creditId, amount: $amount, expiryDate: $expiryDate ) {
            id
            amount
            expiryDate
            updatedAt
        }
    }
`
export const deleteCredit = gql`
    mutation DeleteCredit($creditId: String!) { 
        deleteCredit(creditId: $creditId)
    }
`

export const updateUser = gql`
    mutation UpdateUser($userId: String!, $email: String, $role: Role, $isPremium: Boolean) {
        updateUser(userId: $userId, email: $email, role: $role, isPremium: $isPremium) {
            id
        }
    }
`

export const Login = gql`
    mutation Login($email: String!, $password: String!) {
        login(email: $email, password: $password) {
            user {
                id
            }
            token
        }
    }
`
export const createExplore = gql`
    mutation CreateExplore($gif: String, $url: String, $thumbnailUrl: String, $aspectRatio: AspectRatioEnum, $style: ArtStyle, $motionScore: MotionScoreEnum, $categoryId: String, $prompt: String) {
        createExplore(gif: $gif, url: $url, thumbnailUrl: $thumbnailUrl, aspectRatio: $aspectRatio, style: $style, motionScore: $motionScore, categoryId: $categoryId, prompt: $prompt) {
            id
            url
            prompt
            thumbnailUrl
            motionScore
            style
            createdAt
            updatedAt
            aspectRatio
            gif
            categoryId
        }
    }
`
export const updateExplore = gql`
    mutation UpdateExplore($exploreId: String, $categoryId: String, $prompt: String, $motionScore: MotionScoreEnum, $style: ArtStyle, $aspectRatio: AspectRatioEnum, $thumbnailUrl: String, $gif: String, $url: String) {
        updateExplore(exploreId: $exploreId, categoryId: $categoryId, prompt: $prompt, motionScore: $motionScore, style: $style, aspectRatio: $aspectRatio, thumbnailUrl: $thumbnailUrl, gif: $gif, url: $url) {
            id
            url
            prompt
            thumbnailUrl
            motionScore
            style
            createdAt
            updatedAt
            aspectRatio
            gif
            categoryId
        }
    }
`
export const createCategory = gql`
    mutation CreateCategory($model: ModelEnum, $prompt: [String!], $gif: String, $description: String, $thumbnailUrl: String, $video: String, $categoryType: CategoryType, $isExplore: Boolean, $name: String) {
        createCategory(model: $model, prompt: $prompt, gif: $gif, description: $description, thumbnailUrl: $thumbnailUrl, video: $video, categoryType: $categoryType, isExplore: $isExplore, name: $name) {
            createdAt
            description
            gif
            id
            isExplore
            model
            name
            prompt
            thumbnail
            type
            updatedAt
            video
        }
    }
`

export const updateCategory = gql`
    mutation UpdateCategory($categoryId: String, $isExplore: Boolean, $categoryType: CategoryType, $name: String, $video: String, $thumbnailUrl: String, $description: String, $gif: String, $prompt: [String!], $model: ModelEnum) {
        updateCategory(categoryId: $categoryId, isExplore: $isExplore, categoryType: $categoryType, name: $name, video: $video, thumbnailUrl: $thumbnailUrl, description: $description, gif: $gif, prompt: $prompt, model: $model) {
            id
            name
            video
            gif
            thumbnail
            description
            prompt
            isExplore
            model
            type
            createdAt
            updatedAt
        }
    }
`
export const updateStyle = gql`
mutation UpdateStyle($designType: StyleDesignEnum!, $rowNumber: Float!, $banner: String!, $name: String!, $styleId: String!, $videoUrl: String, $gifUrl: String, $webmUrl: String, $webpUrl: String, $isFuture: Boolean!, $isPublic: Boolean!, $tagIds: [String!], $highlighted: Boolean!, $toolType: ToolType, $promptIds: [String!], $sectionIds: [String!], $secondBanner: String) {
  updateStyle(designType: $designType, rowNumber: $rowNumber, banner: $banner, name: $name, styleId: $styleId, videoUrl: $videoUrl, gifUrl: $gifUrl, webmUrl: $webmUrl, webpUrl: $webpUrl, isFuture: $isFuture, isPublic: $isPublic, tagIds: $tagIds, highlighted: $highlighted, toolType: $toolType, promptIds: $promptIds, sectionIds: $sectionIds, secondBanner: $secondBanner) {
    id
  }
}
`
export const createStyle = gql`
mutation CreateStyle($designType: StyleDesignEnum!, $rowNumber: Float!, $banner: String!, $name: String!, $isFuture: Boolean!, $isPublic: Boolean!, $videoUrl: String, $gifUrl: String, $webmUrl: String, $webpUrl: String, $tagIds: [String!], $highlighted: Boolean!, $toolType: ToolType, $promptIds: [String!], $sectionIds: [String!], $secondBanner: String) {
  createStyle(designType: $designType, rowNumber: $rowNumber, banner: $banner, name: $name, isFuture: $isFuture, isPublic: $isPublic, videoUrl: $videoUrl, gifUrl: $gifUrl, webmUrl: $webmUrl, webpUrl: $webpUrl, tagIds: $tagIds, highlighted: $highlighted, toolType: $toolType, promptIds: $promptIds, sectionIds: $sectionIds, secondBanner: $secondBanner) {
    id
  }
}
`
export const createPrompt = gql`
mutation CreatePrompt($outputQuality: Float!, $outputFormat: String!, $numInferenceSteps: Float!, $loraScale: Float!, $guidanceScale: Float!, $gender: Gender!, $numOfOutPuts: Float!, $aspectRatio: String!, $isVisible: Boolean!, $isPublic: Boolean!, $rowNumber: Float!, $prompt: String!, $promptSvg: String, $beforeImage: String, $banner: String, $gifUrl: String, $webmUrl: String, $webpUrl: String, $videoUrl: String, $designType: StyleDesignEnum!, $toolType: ToolType!,$tagIds: [String!],$highlighted: Boolean!,$intputImageCount: Float!,$templateId: String, $inferanceModelEnum: InferanceModelEnum, $cost: Float, $secondBanner: String, $detailImage: String, $name: String) {
  createPrompt(outputQuality: $outputQuality, outputFormat: $outputFormat, numInferenceSteps: $numInferenceSteps, loraScale: $loraScale, guidanceScale: $guidanceScale, gender: $gender, numOfOutPuts: $numOfOutPuts, aspectRatio: $aspectRatio, isVisible: $isVisible, isPublic: $isPublic, rowNumber: $rowNumber, prompt: $prompt, promptSvg: $promptSvg, beforeImage: $beforeImage, banner: $banner, gifUrl: $gifUrl, webmUrl: $webmUrl, webpUrl: $webpUrl, videoUrl: $videoUrl, designType: $designType, toolType: $toolType, tagIds: $tagIds, highlighted: $highlighted,intputImageCount: $intputImageCount, templateId: $templateId, inferanceModelEnum: $inferanceModelEnum, cost: $cost, secondBanner: $secondBanner, detailImage: $detailImage, name: $name) {
    id
  }
}
`
export const updatePrompt = gql`
mutation UpdatePrompt($outputQuality: Float!, $outputFormat: String!, $numInferenceSteps: Float!, $loraScale: Float!, $guidanceScale: Float!, $gender: Gender!, $numOfOutPuts: Float!, $aspectRatio: String!, $isVisible: Boolean!, $isPublic: Boolean!, $rowNumber: Float!, $prompt: String!, $promptId: String!, $promptSvg: String, $beforeImage: String, $banner: String, $gifUrl: String, $webmUrl: String, $webpUrl: String, $videoUrl: String, $designType: StyleDesignEnum!, $toolType: ToolType!, $tagIds: [String!],$highlighted: Boolean!,$intputImageCount: Float!,$templateId: String, $inferanceModelEnum: InferanceModelEnum, $cost: Float, $secondBanner: String, $detailImage: String, $name: String) {
  updatePrompt(outputQuality: $outputQuality, outputFormat: $outputFormat, numInferenceSteps: $numInferenceSteps, loraScale: $loraScale, guidanceScale: $guidanceScale, gender: $gender, numOfOutPuts: $numOfOutPuts, aspectRatio: $aspectRatio, isVisible: $isVisible, isPublic: $isPublic, rowNumber: $rowNumber, prompt: $prompt, promptId: $promptId, promptSvg: $promptSvg, beforeImage: $beforeImage, banner: $banner, gifUrl: $gifUrl, webmUrl: $webmUrl, webpUrl: $webpUrl, videoUrl: $videoUrl, designType: $designType, toolType: $toolType, tagIds: $tagIds, highlighted: $highlighted,intputImageCount: $intputImageCount, templateId: $templateId, inferanceModelEnum: $inferanceModelEnum, cost: $cost, secondBanner: $secondBanner, detailImage: $detailImage, name: $name) {
    id
  }
}
`
export const deleteStyle = gql`
    mutation DeleteStyle($styleId: String!) {
        deleteStyle(styleId: $styleId)
    }
`
export const deletePrompt = gql`
    mutation DeletePrompt($promptId: String!) {
        deletePrompt(promptId: $promptId)
    }
`

export const createSection = gql`
mutation CreateSection($isPublic: Boolean!, $designType: StyleDesignEnum!, $rowNumber: Float!, $name: String!, $banner: String, $gifUrl: String, $webmUrl: String, $webpUrl: String, $videoUrl: String, $styleIds: [String!], $promptIds: [String!], $tagIds: [String!],$highlighted: Boolean!, $secondBanner: String) {
  createSection(isPublic: $isPublic, designType: $designType, rowNumber: $rowNumber, name: $name, banner: $banner, gifUrl: $gifUrl, webmUrl: $webmUrl, webpUrl: $webpUrl, videoUrl: $videoUrl, styleIds: $styleIds, promptIds: $promptIds, tagIds: $tagIds, highlighted: $highlighted, secondBanner: $secondBanner) {
    id
    createdAt
    name
    rowNumber
    designType
    isPublic
    updatedAt
    tools {
      id
      name
    }
    styles {
      id
      name
    }
  }
}
`

export const updateSection = gql`
mutation UpdateSection($highlighted: Boolean!, $isPublic: Boolean!, $designType: StyleDesignEnum!, $rowNumber: Float!, $name: String!, $sectionId: String!, $banner: String, $gifUrl: String, $webmUrl: String, $webpUrl: String, $videoUrl: String, $tagIds: [String!], $promptIds: [String!], $styleIds: [String!], $secondBanner: String) {
  updateSection(highlighted: $highlighted, isPublic: $isPublic, designType: $designType, rowNumber: $rowNumber, name: $name, sectionId: $sectionId, banner: $banner, gifUrl: $gifUrl, webmUrl: $webmUrl, webpUrl: $webpUrl, videoUrl: $videoUrl, tagIds: $tagIds, promptIds: $promptIds, styleIds: $styleIds, secondBanner: $secondBanner) {
    id
    name
    rowNumber
    designType
    isPublic
    createdAt
    updatedAt
    tools {
      id
      name
      banner
    }
    styles {
      id
      name
      banner
    }
  }
}
`

export const updatePromptPublicAndRowNumber = gql`
mutation UpdatePromptPublicAndRowNumber($rowNumber: Float!, $isPublic: Boolean!, $promptId: String!) {
  updatePromptPublicAndRowNumber(rowNumber: $rowNumber, isPublic: $isPublic, promptId: $promptId) {
    id
    name
  }
}
`

export const updateStylePublicAndRowNumber = gql`
mutation UpdateStylePublicAndRowNumber($rowNumber: Float!, $isPublic: Boolean!, $styleId: String!) {
  updateStylePublicAndRowNumber(rowNumber: $rowNumber, isPublic: $isPublic, styleId: $styleId) {
    id
    banner
  }
}
`

export const updateSectionPublicAndRowNumber = gql`
mutation UpdateSectionPublicAndRowNumber($rowNumber: Float!, $isPublic: Boolean!, $sectionId: String!) {
  updateSectionPublicAndRowNumber(rowNumber: $rowNumber, isPublic: $isPublic, sectionId: $sectionId) {
    id
    name
  }
}
`

export const createTag = gql`
mutation CreateTag($name: String!, $isDefault: Boolean) {
  createTag(name: $name, isDefault: $isDefault) {
    id
    name
    createdAt
    updatedAt
  }
}
`

export const updateTag = gql`
mutation UpdateTag($name: String!, $tagId: String!, $isDefault: Boolean) {
  updateTag(name: $name, tagId: $tagId, isDefault: $isDefault) {
    name
    id
    isDefault
    createdAt
  }
}
`

export const deleteTag = gql`
    mutation DeleteTag($tagId: String!) {
        deleteTag(tagId: $tagId)
    }
`

export const createExploreRow = gql`
    mutation CreateExploreRow($order: Int!, $isHighlighted: Boolean!, $contentId: String!, $contentType: ContentTypeEnum!, $platform: [SystemVideoEnableEnum!], $tagId: String) {
        createExploreRow(
            order: $order
            isHighlighted: $isHighlighted
            contentId: $contentId
            contentType: $contentType
            platform: $platform
            tagId: $tagId
        ) {
            id
            order
            isHighlighted
            contentId
            contentType
            platform
            tagId
            createdAt
            updatedAt
        }
    }
`

export const updateExploreRow = gql`
    mutation UpdateExploreRow($id: String!, $order: Int, $isHighlighted: Boolean, $contentId: String, $contentType: ContentTypeEnum, $platform: SystemVideoEnableEnum, $tagId: String) {
        updateExploreRow(
            id: $id
            order: $order
            isHighlighted: $isHighlighted
            contentId: $contentId
            contentType: $contentType
            platform: $platform
            tagId: $tagId
        ) {
            id
            order
            isHighlighted
            contentId
            contentType
            platform
            tagId
            createdAt
            updatedAt
        }
    }
`

export const deleteExploreRow = gql`
    mutation DeleteExploreRow($id: String!) {
        deleteExploreRow(id: $id)
    }
`

export const reorderExploreRows = gql`
    mutation ReorderExploreRows($updates: [ExploreRowOrderUpdate!]!) {
        reorderExploreRows(updates: $updates)
    }
`

export const createContent = gql`
    mutation CreateContent(
        $contentId: String!,
        $contentType: ContentTypeEnum!,
        $videoUrl: String,
        $banner: String,
        $secondBanner: String,
        $gifUrl: String,
        $webmUrl: String,
        $webpUrl: String,
        $detailImage: String,
        $designType: StyleDesignEnum!,
        $tagId: String,
        $rowNumber: Float,
        $sectionId: String,
        $styleId: String,
        $promptId: String
    ) {
        createContent(
            contentId: $contentId
            contentType: $contentType
            videoUrl: $videoUrl
            banner: $banner
            secondBanner: $secondBanner
            gifUrl: $gifUrl
            webmUrl: $webmUrl
            webpUrl: $webpUrl
            detailImage: $detailImage
            designType: $designType
            tagId: $tagId
            rowNumber: $rowNumber
            sectionId: $sectionId
            styleId: $styleId
            promptId: $promptId
        ) {
            id
            contentId
            contentType
            videoUrl
            banner
            gifUrl
            designType
            tagId
            rowNumber
            sectionId
            styleId
            promptId
            createdAt
            updatedAt
            tag {
                id
                name
            }
            section {
                id
                name
            }
            style {
                id
                name
            }
            prompt {
                id
                name
            }
        }
    }
`

export const updateContent = gql`
    mutation UpdateContent(
        $id: String!,
        $contentId: String,
        $contentType: ContentTypeEnum,
        $videoUrl: String,
        $banner: String,
        $secondBanner: String,
        $gifUrl: String,
        $webmUrl: String,
        $webpUrl: String,
        $detailImage: String,
        $designType: StyleDesignEnum,
        $tagId: String,
        $rowNumber: Float,
        $sectionId: String,
        $styleId: String,
        $promptId: String
    ) {
        updateContent(
            id: $id
            contentId: $contentId
            contentType: $contentType
            videoUrl: $videoUrl
            banner: $banner
            secondBanner: $secondBanner
            gifUrl: $gifUrl
            webmUrl: $webmUrl
            webpUrl: $webpUrl
            detailImage: $detailImage
            designType: $designType
            tagId: $tagId
            rowNumber: $rowNumber
            sectionId: $sectionId
            styleId: $styleId
            promptId: $promptId
        ) {
            id
            contentId
            contentType
            videoUrl
            banner
            gifUrl
            designType
            tagId
            rowNumber
            sectionId
            styleId
            detailImage
            promptId
            createdAt
            updatedAt
            tag {
                id
                name
            }
            section {
                id
                name
            }
            style {
                id
                name
            }
            prompt {
                id
                name
            }
        }
    }
`

export const deleteContent = gql`
    mutation DeleteContent($id: String!) {
        deleteContent(id: $id)
    }
`

export const createSystemConfig = gql`
    mutation CreateSystemConfig($provider: ProviderEnum!, $systemType: ToolType!, $systemModel: String) {
        createSystemConfig(provider: $provider, systemType: $systemType, systemModel: $systemModel) {
            id
            provider
            systemType
            systemModel
            createdAt
            updatedAt
        }
    }
`

export const updateSystemConfig = gql`
    mutation UpdateSystemConfig($id: String!, $provider: ProviderEnum, $systemType: ToolType, $systemModel: String) {
        updateSystemConfig(id: $id, provider: $provider, systemType: $systemType, systemModel: $systemModel) {
            id
            provider
            systemType
            systemModel
            createdAt
            updatedAt
        }
    }
`

export const deleteSystemConfig = gql`
    mutation DeleteSystemConfig($id: String!) {
        deleteSystemConfig(id: $id)
    }
`

export const createRevenueCatProduct = gql`
    mutation CreateRevenueCatProduct($input: CreateCreditProductInput!) {
        createCreditProduct(input: $input) {
            id
            name
            amount
            startDate
            endDate
            limit
            price
            type
            createdAt
            updatedAt
        }
    }
`

export const updateRevenueCatProduct = gql`
    mutation UpdateRevenueCatProduct($id: String!, $input: UpdateCreditProductInput!) {
        updateCreditProduct(id: $id, input: $input) {
            id
            name
            amount
            startDate
            endDate
            limit
            price
            type
            createdAt
            updatedAt
        }
    }
`

export const deleteRevenueCatProduct = gql`
    mutation DeleteRevenueCatProduct($id: String!) {
        deleteCreditProduct(id: $id)
    }
`

// ToolRatio Mutations
export const createToolRatio = gql`
    mutation CreateToolRatio($width: Int!, $height: Int!, $name: String!, $aspectRatioX: Int!, $aspectRatioY: Int!, $toolId: String!) {
        createToolRatio(width: $width, height: $height, name: $name, aspectRatioX: $aspectRatioX, aspectRatioY: $aspectRatioY, toolId: $toolId) {
            id
            width
            height
            name
            aspectRatioX
            aspectRatioY
            toolId
            createdAt
            updatedAt
        }
    }
`

export const updateToolRatio = gql`
    mutation UpdateToolRatio($id: String!, $width: Int, $height: Int, $name: String, $aspectRatioX: Int, $aspectRatioY: Int, $toolId: String) {
        updateToolRatio(id: $id, width: $width, height: $height, name: $name, aspectRatioX: $aspectRatioX, aspectRatioY: $aspectRatioY, toolId: $toolId) {
            id
            width
            height
            name
            aspectRatioX
            aspectRatioY
            toolId
            createdAt
            updatedAt
        }
    }
`

export const deleteToolRatio = gql`
    mutation DeleteToolRatio($id: String!) {
        deleteToolRatio(id: $id)
    }
`

export const addRatioToPrompt = gql`
    mutation AddRatioToPrompt($promptId: String!, $width: Int!, $height: Int!, $name: String!, $aspectRatioX: Int!, $aspectRatioY: Int!) {
        addRatioToPrompt(promptId: $promptId, width: $width, height: $height, name: $name, aspectRatioX: $aspectRatioX, aspectRatioY: $aspectRatioY) {
            id
            width
            height
            name
            aspectRatioX
            aspectRatioY
            toolId
            createdAt
            updatedAt
        }
    }
`

export const removeRatioFromPrompt = gql`
    mutation RemoveRatioFromPrompt($promptId: String!, $ratioId: String!) {
        removeRatioFromPrompt(promptId: $promptId, ratioId: $ratioId)
    }
`

export const updateModelAdmin = gql`
    mutation UpdateModelAdmin($modelId: String!, $status: ReplicateStatusEnum!) {
        updateModelAdmin(modelId: $modelId, status: $status) {
            id
            status
        }
    }
`

export const updateSetAdmin = gql`
mutation UpdateSetAdmin($setId: String!, $status: ReplicateStatusEnum) {
  updateSetAdmin(setId: $setId, status: $status) {
    id
  }
}
`

export const deleteSection = gql`
mutation DeleteSection($sectionId: String!) {
  deleteSection(sectionId: $sectionId)
}
`

export const deleteMultipleContent = gql`
mutation DeleteMultipleContent($ids: [String!]!) {
  deleteMultipleContent(ids: $ids)
}
`

export const reorderContent = gql`
mutation ReorderContent($updates: [ContentOrderUpdate!]!) {
  reorderContent(updates: $updates)
}
`